import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-2 text-sm">
      <Link to="/" className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {item.to ? (
            <Link to={item.to} className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}